// @flow

import type {ActiveMerchant} from 'docs/data';
import type {AccountRequestModel, MerchantRequestModel} from 'docs/types';

// TODO(nkohari): The merchant is mocked up like this for simplicity in Markdoc. However, it feels
// like a really bad code smell. Can we change this to only mock the merchant as a variable in Markdoc?
// We'd need to ensure the rest of the Docs app didn't assume that account.merchant was always set.
export const createMockMerchant = (
  request: AccountRequestModel,
): ActiveMerchant => ({
  apiVersion: request.api_version,
  isLoggedIn: false,
  currency: 'usd',
  defaultCurrency: 'usd',
  country: '',
  created: null,
  iconUrl: '',
  nickname: '',
  token: '',
});

export const transformMerchant = (
  model: MerchantRequestModel,
  apiVersion: string, // TODO (nkohari): Remove this if we can get rid of the mock merchant
): ActiveMerchant => ({
  apiVersion,
  isLoggedIn: true,
  currency: model.currency,
  defaultCurrency: model.currency, // TODO (nkohari): Remove this
  country: model.country,
  created: model.created_timestamp * 1000,
  iconUrl: model.icon_url || '',
  nickname: model.nickname || '',
  token: model.token,
});
